import React from 'react';
import { Card, Tag, Typography, Space } from 'antd';
import dayjs from 'dayjs';

const { Text } = Typography;

// Contrato de GET /api/professor/turmas (Fase 14C): id, nome_turm,
// modalidade_nome, unidade_nome, dias_semana, hora_inicio, hora_fim,
// data_inicio, data_fim. Sem id_equipe/professor_nome/dado financeiro.
// Ativa/Futura/Encerrada é classificação puramente visual, derivada de
// data_inicio/data_fim vs. hoje -- nunca persistida, nunca vinda do
// backend.

const DIA_LABEL = {
  SEGUNDA: 'Segunda',
  TERCA: 'Terça',
  QUARTA: 'Quarta',
  QUINTA: 'Quinta',
  SEXTA: 'Sexta',
  SABADO: 'Sábado',
  DOMINGO: 'Domingo',
};

const formatarDiasSemana = (dias) => {
  if (!Array.isArray(dias) || dias.length === 0) return 'Dias não definidos';
  const labels = dias.map((d) => DIA_LABEL[d] || d);
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} e ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')} e ${labels[labels.length - 1]}`;
};

const formatarHorario = (inicio, fim) => {
  if (!inicio || !fim) return 'Horário não definido';
  return `${inicio.slice(0, 5)} - ${fim.slice(0, 5)}`;
};

const formatarPeriodo = (dataInicio, dataFim) => {
  const inicio = dataInicio ? dayjs(dataInicio).format('DD/MM/YYYY') : null;
  const fim = dataFim ? dayjs(dataFim).format('DD/MM/YYYY') : null;
  if (!inicio && !fim) return 'Sem período definido';
  if (inicio && !fim) return `A partir de ${inicio}`;
  if (!inicio && fim) return `Até ${fim}`;
  return `${inicio} - ${fim}`;
};

// NULL = sem limite naquela ponta (mesma semântica já estabelecida em
// preparar_encontros_professor/relatorio_repasse_global para
// data_inicio/data_fim de Turma).
const classificarStatusVisual = (dataInicio, dataFim) => {
  const hoje = dayjs().startOf('day');
  if (dataInicio && dayjs(dataInicio).isAfter(hoje, 'day')) return 'FUTURA';
  if (dataFim && dayjs(dataFim).isBefore(hoje, 'day')) return 'ENCERRADA';
  return 'ATIVA';
};

const STATUS_VISUAL_INFO = {
  ATIVA: { color: 'green', text: 'Ativa' },
  FUTURA: { color: 'blue', text: 'Futura' },
  ENCERRADA: { color: 'default', text: 'Encerrada' },
};

const TurmaProfessorCard = ({ turma }) => {
  const statusVisual = classificarStatusVisual(turma.data_inicio, turma.data_fim);
  const statusInfo = STATUS_VISUAL_INFO[statusVisual];

  return (
    <Card className="portal-professor__card" data-testid="turma-card">
      <Space direction="vertical" size={2} style={{ width: '100%' }}>
        <Text strong style={{ fontSize: 16, lineHeight: 1.3, wordBreak: 'break-word' }}>
          {turma.nome_turm}
        </Text>
        <Text type="secondary" style={{ fontSize: 13, wordBreak: 'break-word' }}>
          {turma.modalidade_nome} • {turma.unidade_nome}
        </Text>
        <Text type="secondary" style={{ fontSize: 13 }}>
          {formatarDiasSemana(turma.dias_semana)}
        </Text>
        <Text type="secondary" style={{ fontSize: 13 }}>
          {formatarHorario(turma.hora_inicio, turma.hora_fim)}
        </Text>
        <Text type="secondary" style={{ fontSize: 13 }}>
          {formatarPeriodo(turma.data_inicio, turma.data_fim)}
        </Text>
        <Tag color={statusInfo.color} style={{ marginTop: 4, width: 'fit-content' }}>
          {statusInfo.text}
        </Tag>
      </Space>
    </Card>
  );
};

export default TurmaProfessorCard;
